/**
 * EstimateStatusBadge - T180
 *
 * Status badge for estimates
 */
import { type EstimateStatus, statusLabels, statusColors } from '../../hooks/useEstimates';

interface EstimateStatusBadgeProps {
  status: EstimateStatus;
  size?: 'sm' | 'md';
}

export function EstimateStatusBadge({ status, size = 'md' }: EstimateStatusBadgeProps) {
  const sizeClasses = size === 'sm' ? 'px-1.5 py-0.5 text-xs' : 'px-2 py-1 text-xs';

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${statusColors[status]} ${sizeClasses}`}>
      {statusLabels[status]}
    </span>
  );
}
